"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useProjectParticipantsContext = exports.ProjectParticipantsContext = void 0;
const React = __importStar(require("react"));
const useProjectParticipantsHook_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/members/useProjectParticipantsHook");
exports.ProjectParticipantsContext = React.createContext({});
const useProjectParticipantsContext = () => React.useContext(exports.ProjectParticipantsContext);
exports.useProjectParticipantsContext = useProjectParticipantsContext;
const ProjectParticipantsProvider = (props) => {
    const value = (0, useProjectParticipantsHook_1.useProjectParticipantsHook)();
    return (React.createElement(exports.ProjectParticipantsContext.Provider, { value: value }, props.children));
};
ProjectParticipantsProvider.displayName = "ProjectParticipantsProvider";
exports.default = ProjectParticipantsProvider;
